// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-builder-dialog,.form-builder-overlay{z-index:100000!important}.form-wrap.form-builder .frmb .form-elements .add{color:#000;height:30px;width:110px}#fb-editor .input-control-0,#fb-editor .input-control-1,#fb-editor .input-control-10{display:none}#nameTemp{width:auto}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
